export default function arrayMin(array) {
  return Math.min(...array);
}
